export enum ConnectLinkType {
  Onboarding = 'account_onboarding',
  Update = 'account_update',
}
